module.exports = __webpack_public_path__ + "static/media/turkey-sm.a8fdb86e.gif";